import { SliceCaseReducers, createSlice } from "@reduxjs/toolkit";
import { ClientBillingTier } from "../../Types/ClientBilling";
import { RootState } from "../Store";

interface BillingTiersState {
  isLoading: boolean;
  attempts: number;
  tiers: ClientBillingTier[];
}

const initialState: BillingTiersState = {
  isLoading: false,
  attempts: 0,
  tiers: [],
};

export const BillingTiersSlice = createSlice<
  BillingTiersState,
  SliceCaseReducers<BillingTiersState>,
  "billingTiers"
>({
  name: "billingTiers",
  initialState,
  reducers: {
    updateTiers: (state: BillingTiersState, action: { payload: ClientBillingTier[] }) => {
      state.tiers = action.payload;
    },
    setLoadingTiers: (state: BillingTiersState, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    },
    addAttempt: (state: BillingTiersState) => {
      state.attempts = state.attempts + 1;
    },
    clearAttempts: (state: BillingTiersState) => {
      state.attempts = 0;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateTiers,
  setLoadingTiers,
  addAttempt,
  clearAttempts,
} = BillingTiersSlice.actions;

export const selectBillingTiers = (state: RootState) => state.billingTiers;

export default BillingTiersSlice.reducer;
